function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@nextcloud/vue/dist/Components/Avatar';
import PopoverMenu from '@nextcloud/vue/dist/Components/PopoverMenu';
import Tooltip from '@nextcloud/vue/dist/Directives/Tooltip';
var COLLABORATOR_IDLE_TIME = 10;
var COLLABORATOR_DISCONNECT_TIME = 30;
export default {
  name: 'SessionList',
  components: {
    Avatar: Avatar,
    PopoverMenu: PopoverMenu
  },
  directives: {
    tooltip: Tooltip
  },
  props: {
    sessions: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      popoverVisible: '',
      myName: ''
    };
  },
  computed: {
    editorsTooltip: function editorsTooltip() {
      if (this.sessionsPopover.length > 0) {
        var first = this.activeSessions.slice(0, 3).map(function (session) {
          return session.guestName ? session.guestName : session.displayName;
        }).join(', ');
        var others = this.activeSessions.slice(3).length;
        return first + ' ' + n('text', 'and %n other editor', 'and %n other editors', others);
      }

      return this.activeSessions.slice(0, 3).map(function (session) {
        return session.guestName ? session.guestName : session.displayName;
      }).join(', ');
    },
    avatarUrl: function avatarUrl() {
      return function (session) {
        var user = !session.guestName ? session.userId : session.guestName;
        var size = 32;
        var guest = !!session.guestName;
        var avatarUrl = OC.generateUrl(guest ? '/avatar/guest/{user}/{size}' : '/avatar/{user}/{size}', {
          user: user,
          size: size
        });
        return window.location.protocol + '//' + window.location.host + avatarUrl;
      };
    },
    activeSessions: function activeSessions() {
      return Object.values(this.sessions).filter(function (session) {
        return session.lastContact > Date.now() / 1000 - COLLABORATOR_DISCONNECT_TIME && !session.isCurrent && (session.userId !== null || session.guestName !== null);
      });
    },
    currentSession: function currentSession() {
      return Object.values(this.sessions).find(function (session) {
        return session.isCurrent;
      });
    },
    sessionStyle: function sessionStyle() {
      return function (session) {
        return {
          'opacity': session.lastContact > Date.now() / 1000 - COLLABORATOR_IDLE_TIME ? 1 : 0.5 // 'border-color': session.color

        };
      };
    },
    sessionsVisible: function sessionsVisible() {
      return this.activeSessions.slice(0, 3);
    },
    sessionsPopover: function sessionsPopover() {
      var _this = this;

      return _toConsumableArray(this.activeSessions.slice(3).map(function (session) {
        return {
          href: '#',
          icon: _this.avatarUrl(session),
          text: session.guestName ? session.guestName : session.displayName
        };
      }));
    }
  },
  methods: {}
};